module.exports = __webpack_public_path__ + "static/media/the-bottles-thumb.d88826fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/the-bottles-thumb.jpg
// module id = 596
// module chunks = 0